export default "__VITE_PUBLIC_ASSET__dc90c96c__"